module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'cookie-law/double-buttons' && templateVars.config ?
				templateVars.config :
				{
	"isStatic": false,
	"showOneTime": false,
	"linkToPage": "${rootUrl}/cookies-policy"
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/cookie-law/.variant/double-buttons/config.yaml
// module id = 169
// module chunks = 0